import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTopHeader, uplodateLoading } from '../../constants/../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast } from '../../constants/toaster';
import { Box, Pagination, Button, Menu, MenuItem, IconButton, TextField } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import InsufficientPermission from '../../custom/InSufficientPermission';
import { useNavigate, useLocation } from 'react-router-dom';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import Utils from '../../constants/Utils'
import { formatIndianNumber } from '../../lib/formatIndianNumber'

const ChipsWalletManager = () => {
         const { formatDate } = Utils();
    
  const dispatch = useDispatch();
  const userData = useSelector(state => state?.userData);
  const userPermisiions = useSelector(state => state?.permission);
  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // ADDED: Page Per Count Feature
  const [limit, setLimit] = useState(10);

  // ADDED: Go To Page Feature
  const [pageInput, setPageInput] = useState(1);
  useEffect(() => {
    setPageInput(page);
  }, [page]);

  let currentModulePermission;
  let viewPermission = true;
  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => element.moduleId === '32')?.permissions;
    if (currentModulePermission) {
      viewPermission = currentModulePermission.find((element) => element.name === 'VIEW')?.isEnable;
    }
  }

  useEffect(() => {
    dispatch(updateTopHeader("Chips Wallet Manager"));
  }, []);

  useEffect(() => {
    const returnTo = location.state;
    if (returnTo && returnTo.page != null) {
      setPage(returnTo.page);
      setLimit(returnTo.limit ?? 10);
      setSearchText(returnTo.searchText ?? '');
      setStartDate(returnTo.startDate ? dayjs(returnTo.startDate) : null);
      setEndDate(returnTo.endDate ? dayjs(returnTo.endDate) : null);
      setPageInput(returnTo.page);
    }
  }, [location.state]);

  useEffect(() => {
    getBeadsBalanceList();
    // eslint-disable-next-line
  }, [page, limit]);

  const getBeadsBalanceList = async (searchValue = searchText, customStartDate = startDate, customEndDate = endDate) => {
    try {
      dispatch(uplodateLoading(true));
      let postJson = {
        sort: 'createdAt',
        order: true,
        page: page - 1,
        limit: limit,
        searchTxt: searchValue,
        transactionType: 'ALL',
        startDate: customStartDate && customStartDate.format ? customStartDate.format('YYYY-MM-DD') : '',
        endDate: customEndDate && customEndDate.format ? customEndDate.format('YYYY-MM-DD') : ''
      };
      let res = await ApiCaller.post(postJson, urls.userBeadsBalanceList, userData?.access_token);
      const response = await res.response.json();
      const apiData = response.data && response.data.data ? response.data.data : response.data;
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.code === '200'
      ) {
        dispatch(uplodateLoading(false));
        setDatalist(Array.isArray(apiData.items) ? apiData.items : []);
        setPagerecord({
          totalItems: apiData.totalItems || (apiData.items ? apiData.items.length : 0),
          totalPages: apiData.totalPages || 1,
          pageNumber: (typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : page),
          pageSize: apiData.pageSize || 10
        });
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message);
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message);
    }
  };

  const handleMenuClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getReturnToState = () => ({
    page,
    limit,
    searchText,
    startDate: startDate ? startDate.format('YYYY-MM-DD') : '',
    endDate: endDate ? endDate.format('YYYY-MM-DD') : ''
  });

  const handleViewHistory = () => {
    setAnchorEl(null);
    if (selectedUser && (selectedUser.email || selectedUser.userName)) {
      navigate(`/view-chips-wallet-history?email=${encodeURIComponent(selectedUser.email || selectedUser.userName)}`, {
        state: { returnTo: getReturnToState() }
      });
    }
  };

  const handleViewHistoryDirect = (item) => {
    if (item && (item.email || item.userName)) {
      navigate(`/view-chips-wallet-history?email=${encodeURIComponent(item.email || item.userName)}`, {
        state: { returnTo: getReturnToState() }
      });
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  // ADDED: Go To Page Feature
  const totalPages = pagerecord?.totalPages || 1;
  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };
  const handlePageInputSubmit = () => {
    const value = Number(pageInput);
    const maxPage = totalPages >= 1 ? totalPages : 1;
    if (!Number.isNaN(value) && value >= 1 && value <= maxPage) {
      setPage(value);
    } else {
      setPageInput(page);
    }
  };

  // ADDED: Page Per Count Feature
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const handleFilterClick = () => {
    setPage(1);
    getBeadsBalanceList(searchText, startDate, endDate);
  };

  const handleResetFilter = () => {
    setSearchText('');
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    getBeadsBalanceList('', null, null);
  };

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {viewPermission ? (
          <div className='container-fluid mt--7'>
            <div className='row'>
              <div className='col text-left'>
                <div className='card shadow mb-4'>
                  <div className='card-header border-0'>
                    <h3 className='mb-0'>Chips Wallet Manager</h3>
                  </div>
                  <div className='card-header border-0'>
                    <div className='row align-items-center text-left'>
                      <div className='col-md-3'>
                        <InputGroup className='mb-2' style={{ borderRadius: '10px' }}>
                          <Form.Control
                            placeholder='Search by User Name'
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            aria-label='Amount (to the nearest dollar)'
                          />
                        </InputGroup>
                      </div>
                      <div className='col-md-6 mb-3' style={{ marginLeft: '40px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                              className='custom-date'
                              label='From Date'
                              value={startDate}
                              onChange={newValue => setStartDate(newValue)}
                              maxDate={endDate || undefined}
                            />
                            <DatePicker
                              label='To Date'
                              value={endDate}
                              onChange={newValue => setEndDate(newValue)}
                              minDate={startDate || undefined}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                      <div className='col-md-3 mb-2'>
                        <Button
                          variant='contained'
                          className='custom-filter-btn'
                          onClick={handleFilterClick}
                        >
                          Filter
                        </Button>
                        <Button
                          variant='contained'
                          className='ml-2 custom-filter-btn'
                          onClick={handleResetFilter}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className='card-body'>
                    <div className='table-responsive'>
                      <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                          <tr>
                            <th>#</th>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Beads</th>
                            <th>Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(datalist) && datalist.length > 0 ? datalist.map((item, idx) => (
                            <tr key={item.userName + idx}>
                              <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                              <td>{item.userName}</td>
                              <td>{item.email || '-'}</td>
                              <td>{item.beads !== undefined && item.beads !== null ? formatIndianNumber(item.beads) : '-'}</td>
                               <td>{formatDate(item?.createdAt)}</td>

                              <td>
                                <Button
                                  variant='outlined'
                                  size='small'
                                  onClick={() => handleViewHistoryDirect(item)}
                                  sx={{ mr: 1 }}
                                >
                                  View
                                </Button>
                                <IconButton onClick={e => handleMenuClick(e, item)}>
                                  <MoreVertIcon />
                                </IconButton>
                              </td>
                            </tr>
                          )) : (
                            <tr><td colSpan={7} className='text-center'>No Data Found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Box display='flex' justifyContent='space-between' alignItems='center' mt={3} flexWrap='wrap' gap={2}>
                      <span>Total record: {pagerecord?.totalItems}</span>
                      <Box display='flex' alignItems='center' gap={2} flexWrap='wrap'>
                        {/* ADDED: Page Per Count Feature */}
                        <Form.Select
                          value={limit}
                          onChange={handleLimitChange}
                          style={{ width: 'auto', minWidth: '70px' }}
                          size='sm'
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </Form.Select>
                        {/* ADDED: Go To Page Feature */}
                        <TextField
                          label='Go to page'
                          type='number'
                          inputProps={{ min: 1, max: totalPages }}
                          value={pageInput}
                          onChange={handlePageInputChange}
                          onBlur={handlePageInputSubmit}
                          onKeyDown={(e) => e.key === 'Enter' && handlePageInputSubmit()}
                          size='small'
                          sx={{ width: 120 }}
                        />
                        <Pagination
                          className='custom-pagination-class'
                          count={pagerecord?.totalPages}
                          page={page}
                          onChange={handleChange}
                          color='secondary'
                        />
                      </Box>
                    </Box>
                  </div>
                </div>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                  <MenuItem onClick={handleViewHistory}>View Transaction History</MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        ) : (
          <InsufficientPermission />
        )}
      </div>
    </>
  );
};

export default ChipsWalletManager;
